import React, { useEffect, useState } from 'react';
import { useDispatch} from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppContext } from 'context/AppContext';
import strings from 'localization/strings';
import { makeStyles } from 'styles/util';
import { handleResponse } from 'actions/actionHelpers';
import { getPregeneratedReport } from 'actions/reports';
import { createTableItems, createTableColumns, createTableFooterCells } from 'helpers/ReportHelper';
import queryString from 'query-string';
import reportDefinitions from 'account/reportDefinitions';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Loader from 'common/Loader';
import AdminTable from 'components/adminTable/AdminTable';

// used by backend to generate reports that are sent as attachments to emails

const useStyles = makeStyles(() => ({
    reportTable: {
        zoom: 0.67,
        '-webkit-print-color-adjust': 'exact !important',
        printColorAdjust: 'exact !important',
        width: 'auto'
    }
}));

const ReportPage = () => {
    const classes = useStyles();
    const location = useLocation();
    const dispatch = useDispatch();
    const parameters = queryString.parse(location.search);
    const { appContext } = useAppContext();

    const [reportData, setReportData] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const reportDefinition = reportDefinitions[parameters.report];
    const columnsToInclude = parameters.columnsToInclude?.split(',');

    useEffect(() => {
        // populate data, either using a pregenerated report, or by creating a report on the fly
        let apiCall;
        if(parameters.guid) {
            apiCall = dispatch(getPregeneratedReport(parameters.guid));
        } else {
            const request = {
                inputFields: {
                    [parameters.report]: {
                        ...parameters,
                        report: undefined
                    }
                }
            };
            apiCall = dispatch(reportDefinition.fetchData(request));
        }

        apiCall.then(handleResponse(
            response => {
                setReportData(response.payload);
                setIsLoading(false);
            }
        ));
    }, []);

    return (
        <Box>
            {
                isLoading && <Loader />
            }
            {
                reportData &&
                (
                    <>
                        {
                            parameters.title && <Typography variant="h1" gutterBottom>{parameters.title}</Typography>
                        }
                        <AdminTable
                            className={classes.reportTable}
                            items={createTableItems(reportData)}
                            columns={createTableColumns(reportData, reportDefinition, columnsToInclude, appContext)}
                            footerCells={createTableFooterCells(reportData, reportDefinition, columnsToInclude, appContext)}
                            noItemsMessage={strings.noItemsMessage}
                        />
                    </>
                )
            }
        </Box>
    );
};

export default ReportPage;
